import { object, ref, string } from "yup";
import { passwordRules } from "../regex/general";

type ChangePasswordFormErrorHeaders = {
    requiredField: string;
    passwordRulesError: string;
    passwordsDontMatch: string;
};

export default function getChangePasswordSchema(
    headers: ChangePasswordFormErrorHeaders,
    labels: { currentPassword: string; newPassword: string; confirmPassword: string }
) {
    const requirements = {
        currentPassword: string().label(labels.currentPassword).required(),
        newPassword: string()
            .label(labels.newPassword)
            .required()
            .matches(passwordRules, headers.passwordRulesError),
        confirmPassword: string()
            .label(labels.confirmPassword)
            .required()
            .equals([ref("newPassword")], headers.passwordsDontMatch),
    };

    return object().shape(requirements);
}
